export default {"src":"/_next/static/media/bcbc.88a8437d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};